import { render, staticRenderFns } from "./QcentrisUnitAllocation.vue?vue&type=template&id=1fce56fa&scoped=true&"
import script from "./QcentrisUnitAllocation.vue?vue&type=script&lang=js&"
export * from "./QcentrisUnitAllocation.vue?vue&type=script&lang=js&"
import style0 from "./QcentrisUnitAllocation.vue?vue&type=style&index=0&id=1fce56fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fce56fa",
  null
  
)

export default component.exports